import { useCallback, useEffect, useState } from "react";
import { get } from "react-hook-form";
import { LadleRelining } from "../models/LadleMaintenance";
import { getLadleMaintenance } from "../repositories/LadleMaintenanceRepository";

interface UseFetchDataProps {
  ladleId: number | null;
  start: Date | undefined;
  ladleSelected: number | null;
}

export const useFetchData = ({
  ladleId,
  start,
  ladleSelected,
}: UseFetchDataProps) => {
  const [ladleRelining, setLadleRelinings] = useState<LadleRelining[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      if (!ladleId) {
        return;
      }

      setLoading(true);
      start?.setHours(0, 0, 0, 0);
      const resp = await getLadleMaintenance({
        ladleId: ladleId || ladleSelected!,
        start: start ? start : undefined,
      });
      if (resp.ok) {
        const ladlesRelinings = get(resp, "data", []);
        setLadleRelinings((ladlesRelinings as LadleRelining[]) || []);
      } else {
        setError(resp.message);
      }
    } catch (e: unknown) {
      if (e instanceof Error) {
        setError(e.message);
      } else {
        setError(String(e));
      }
    } finally {
      setLoading(false);
    }
  }, [ladleId, start, ladleSelected]);

  useEffect(() => {
    fetchData();
  }, [ladleId, fetchData]);

  const refetch = () => {
    fetchData();
  };

  return { ladleRelining, loading, error, setError, refetch };
};
